import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import httpRequest from '@/utils/httpRequest'
import '@/plugins/element.js'
import VideoPlayer from 'vue-video-player'
import 'lib-flexible'


require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.config.productionTip = false
Vue.prototype.$http = httpRequest 
Vue.use(VideoPlayer)

new Vue({
  router,
  store,
  render: h => h(App),

}).$mount('#app')
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
